import { restoreScript } from '@core/utils/dom';
import { Utilities } from './Utilities';
export class ComponentFactory {
    constructor(contexts) {
        this.objects = [];
        Utilities.forEach(contexts, context => {
            if (typeof window.WidgetView?.[context.type] !== 'undefined') {
                this.objects.push(new window.WidgetView[context.type](restoreScript(context)));
            }
        });
    }
}
